module.exports = __webpack_public_path__ + "img/img3.09eef20d.png";